/** Glyph-only Not Tracked icon (actions menu, inline uses). */
export default function SubmittalUntrackCiqIcon({
  size = 12,
  className = "fill-black",
  opacity = "0.45"
}: {
  size?: number;
  className?: string;
  opacity?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.6667 6.87892C16.1633 6.52783 15.602 6.25408 15 6.07492V3.33333H7.98817L6.32149 1.66667H1.66667V13.3333H7.74158C7.92075 13.9353 8.1945 14.4967 8.54558 15H0.833333C0.3731 15 0 14.6269 0 14.1667V0.833333C0 0.3731 0.3731 0 0.833333 0H7.01183L8.6785 1.66667H15.8333C16.2936 1.66667 16.6667 2.03977 16.6667 2.5V6.87892ZM13.3333 15.8333C11.0322 15.8333 9.16667 13.9678 9.16667 11.6667C9.16667 9.3655 11.0322 7.5 13.3333 7.5C15.6345 7.5 17.5 9.3655 17.5 11.6667C17.5 13.9678 15.6345 15.8333 13.3333 15.8333ZM12.2555 13.923C12.5818 14.0792 12.9474 14.1667 13.3333 14.1667C14.7141 14.1667 15.8333 13.0474 15.8333 11.6667C15.8333 11.2808 15.7458 10.9152 15.5897 10.5888L12.2555 13.923ZM11.077 12.7445L14.4112 9.41033C14.0848 9.25417 13.7192 9.16667 13.3333 9.16667C11.9526 9.16667 10.8333 10.2859 10.8333 11.6667C10.8333 12.0526 10.9208 12.4182 11.077 12.7445Z"
        fill="currentColor"
        fillOpacity={opacity}
      />
    </svg>
  );
}
